





























































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

import TenantUserDetail from '@/components/TenantUserDetail.vue'

@Component({
  components: {TenantUserDetail}
})
export default class TableTenantUsers extends Vue {
  selected: any = {}
  @Prop({ default: [] }) users: any[]

  @Emit('sendInvite')
  sendInvite(user: any) {
    return user
  }
}
